import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	'townsquare.api.goal-type-name.goal': {
		id: 'townsquare.api.goal-type-name.goal',
		defaultMessage: 'Goal',
		description: 'Label used to refer to a goal item in headings, buttons, and navigation throughout the application.',
	},
	'townsquare.api.goal-type-name.objective': {
		id: 'townsquare.api.goal-type-name.objective',
		defaultMessage: 'Objective',
		description:
			'Label used to refer to an objective item in headings, buttons, and navigation throughout the application.',
	},
	'townsquare.api.goal-type-name.key-result': {
		id: 'townsquare.api.goal-type-name.key-result',
		defaultMessage: 'Key result',
		description:
			'Label used to refer to a key result item in headings, buttons, and navigation throughout the application.',
	},
});

type MessageId = keyof typeof messages;

export const isNameMessageId = (id: string | null): id is MessageId => {
	return id != null && id in messages;
};
